import swal from 'sweetalert';
import DisplayItem from '@/models/DisplayItem';

class AlertUtility {
  static displayQuestionDialog(title: string, text: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      swal({
        title: title,
        text: text,
      }).then((submit) => {
        if (submit) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  static displayQuestionDialogWithCustomButtonText(
    title: string,
    text: string,
    cancelText: string,
    okText: string
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      swal({
        title: title,
        text: text,
        className: 'regular-alert',
        buttons: {
          catch: {
            text: cancelText,
            value: 'cancel',
          },
          ok: {
            text: okText,
            value: 'ok',
          },
        },
      }).then((value) => {
        switch (value) {
          case 'ok': {
            resolve();
            break;
          }

          case 'cancel': {
            reject();
            break;
          }

          default: {
            reject();
          }
        }
      });
    });
  }

  static displayInformationDialog(title: string, text: string): Promise<void> {
    return AlertUtility.handleDisplayDialog(title, text, 'success');
  }

  static displayErrorDialog(title: string, text: string): Promise<void> {
    return AlertUtility.handleDisplayDialog(title, text, 'error');
  }

  private static handleDisplayDialog(title: string, text: string, icon: string): Promise<void> {
    return new Promise<void>((resolve) => {
      swal({
        title: title,
        text: text,
        icon: icon,
      }).then(() => {
        resolve();
      });
    });
  }

  static displayTimerDialog(title: string, buttonText: string): Promise<void> {
    return new Promise<void>((resolve) => {
      const svgDataUri =
        'data:image/svg+xml;base64,' +
        btoa(`<svg fill="#000000" height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 296.228 296.228" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 296.228 296.228">
        <g>
          <path d="m167.364,48.003v-23.003h10.5c6.903,0 12.5-5.597 12.5-12.5s-5.596-12.5-12.5-12.5h-59.5c-6.903,0-12.5,5.597-12.5,12.5s5.597,12.5 12.5,12.5h10.5v23.003c-59.738,9.285-105.604,61.071-105.604,123.37-3.55271e-15,68.845 56.01,124.854 124.854,124.854s124.854-56.01 124.854-124.854c0-62.299-45.866-114.085-105.604-123.37zm-19.25,223.225c-55.06,0-99.854-44.795-99.854-99.854s44.795-99.854 99.854-99.854 99.854,44.795 99.854,99.854-44.794,99.854-99.854,99.854z"/>
          <path d="m160.614,166.18v-58.889c0-6.903-5.597-12.5-12.5-12.5s-12.5,5.597-12.5,12.5v66.1c0,2.033 0.81,3.982 2.25,5.416l34.969,34.822c4.893,4.872 12.806,4.854 17.678-0.037 4.871-4.892 4.854-12.807-0.037-17.678l-29.86-29.734z"/>
        </g>
      </svg>`);

      swal({
        content: {
          element: 'div',
          attributes: {
            innerHTML:
              '<img src="' +
              svgDataUri +
              '" alt="Timer Icon" width="50" height="50">' +
              '<div style="margin-top: 30px;">' +
              '<h4>' +
              title +
              '</h4>' +
              '</div>' +
              '<hr style="margin-top: 40px;">',
          },
        },
        buttons: {
          confirm: {
            text: buttonText,
          },
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
      }).then(() => {
        resolve();
      });
    });
  }

  static isNavigationAllowed(item: DisplayItem | null | undefined): boolean {
    if (!item) {
      return true;
    }

    const i18n = (window as any).i18n.global;
    const deliveryOptions = item.section.deliveryOptions;
    if (deliveryOptions.length > 0) {
      const timerType = deliveryOptions[0].settings.get('time_limit_type');
      const elapsedTime = deliveryOptions[0].settings.get('elapsedTime');
      const timeLimit = deliveryOptions[0].settings.get('time_limit');

      if (timerType === 'Hard' && typeof elapsedTime === 'string' && typeof timeLimit === 'string') {
        const parsedElapsedTime = parseInt(elapsedTime);
        const parsedTimeLimit = parseInt(timeLimit);

        // Check if parsing is successful and elapsedTime is greater than or equal to timeLimit
        if (!isNaN(parsedElapsedTime) && !isNaN(parsedTimeLimit) && parsedElapsedTime >= parsedTimeLimit) {
          AlertUtility.displayTimerDialog(i18n.t('modal.section_return_timer_expired'), i18n.t('btn.ok'));
          return false;
        }
      }
    }

    return true;
  }
}

export default AlertUtility;
